import React, { useState } from "react";
import { motion } from "framer-motion/dist/framer-motion";
import Typewriter from "../components/Typewriter";
import { INTRO_TITLE, INTRO_LINES, INTRO_CTA } from "../MothersDayData";

const IntroAct = ({ onNext }) => {
  const [done, setDone] = useState(false);
  const [skip, setSkip] = useState(false);

  return (
    <motion.div
      className="md-act md-act-intro"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.7 }}
    >
      <div className="md-letter-card">
        <motion.h1
          initial={{ y: 16, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.7 }}
        >
          {INTRO_TITLE}
        </motion.h1>

        <div className="md-letter-body">
          <Typewriter
            lines={INTRO_LINES}
            speed={28}
            lineDelay={220}
            skip={skip}
            onDone={() => setDone(true)}
          />
        </div>

        <div className="md-intro-cta-row">
          {!done ? (
            <button
              className="md-btn-soft md-btn-ghost md-intro-skip"
              onClick={() => setSkip(true)}
              aria-label="skip the writing animation"
            >
              skip writing →
            </button>
          ) : (
            <motion.button
              className="md-btn-soft md-cta md-intro-begin"
              onClick={onNext}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
            >
              {INTRO_CTA}
            </motion.button>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default IntroAct;
